<template>
	<div class="leftBottomRight">
		<el-popover
			placement="bottom"
			trigger="click">
			<el-checkbox-group v-model="checkList" @change="getChange" id="dwwdwww" style="display: flex;flex-direction: column;">
				<el-checkbox style="padding: 0.2vw;" v-for="(obj, $index) in domEventType" :key="$index" :label="obj.code"><span style="font-size: 0.6vw;height: 0.7vw;line-height: 0.7vw;">{{ obj.name }}</span></el-checkbox>
			</el-checkbox-group>
			<img slot="reference" src="../../../../static/imgV2/search.png" class="searchImg" alt="">
		</el-popover>
		<div class="bottom1">
			<div class="ulDiv" v-for="(obj, $index) in imgs2" :key="$index">
				<img src="../../../../static/imgV2/title2x.png" class="img1" alt="">
				<div class="ulDom">
					<div style="width: 50%;">
						<marquee :val="obj.name"></marquee>
					</div>
					<div style="width: 50%;">
						<marquee :val="obj.insDate"></marquee>
					</div>
				</div>
				<img v-if="!obj.type" src="../../../../static/imgV2/login-1.png" style="position: absolute;top: 15%;left: 0;width: 100%;height: 75%;z-index: 4;" />
				<img :src="obj.imgUrl" :class="obj.type ? 'img2' : 'error-img'" @click="obj.type ? drawMap(obj) : ''" alt="" @error="imgOnerror($event, obj)" >
			</div>
		</div>
		<div class="bottom2">
			<div class="ulDiv" v-for="(obj, $index) in imgs1" :key="$index">
				<img src="../../../../static/imgV2/title2x.png" class="img1" alt="">
				<div class="ulDom">
					<div style="width: 50%;">
						<marquee :val="obj.positonName"></marquee>
					</div>
					<div style="width: 50%;">
						<marquee :val="obj.insDate"></marquee>
					</div>
				</div>
				<img v-if="!obj.type" src="../../../../static/imgV2/login-1.png" style="position: absolute;top: 15%;left: 0;width: 100%;height: 75%;z-index: 4;" />
				<img :src="obj.imgUrl"  alt="" :class="obj.type ? 'img2' : 'error-img'" @click="obj.type ? drawMap(obj) : ''" >
			</div>
		</div>
	</div>
</template>

<script>
	import marquee from '@/components/marquee.vue'
	import {
		getEventImgListByType,
		excludeCheckPatrolEventTypeList
	} from '@/api/indexV2'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				checkList: [],
				ulList: {
					imgList: [],
					patrolImgList: []
				},
				domEventType: [],
				groupLits: "",
				imgs1: [],
				imgs2: [],
				errorImg: require("../../../../static/imgV2/noneImg.png")
			}
		},
		components: {
			marquee
		},
		props: {
			changeTime: Boolean
		},
		mounted() {
			let that = this
			that.excludeCheckPatrolEventTypeList(getItem('tenantInfoId'))
		},
		methods: {
			imgOnerror(event, obj) {
				obj.type = false
				let img = event.srcElement
				img.src = this.errorImg
			},
			checkImg(url){
				let that = this;
				return new Promise((resove, reject) => {
					let img = new Image();
					img.src = url;
					img.onload = (res)=>{
						resove(url);
					}
					img.onerror = () => {
						reject(that.errorImg);
					}
				});
			},
			getChange(data) {
				this.groupLits = data.toString()
				this.getEventImgListByType(data.toString())
			},
			excludeCheckPatrolEventTypeList(tId) {
				let that = this
				excludeCheckPatrolEventTypeList(tId).then(res => {
					if (res && res.data.length > 0) {
						that.domEventType = res.data
						let allCode = []
						res.data.forEach(res => { allCode.push(res.code) })
						that.groupLits = allCode.toString()
						that.getEventImgListByType(allCode.toString())
					}
				})
			},
			getEventImgListByType(typeString) {
				let that = this
				getEventImgListByType({
					tenantInfoId: getItem('tenantInfoId'),
					eventTypeCode: typeString
				}).then(res => {
					if (res && res.data) {
						let list1 = res.data.patrolImgList.map(item => {
							that.checkImg(item.imgUrl).then(res => item.imgUrl = res).catch(err => {item.imgUrl = err; item.type = false});
							return item;
						});
						that.imgs1 = list1;
						let list2 = res.data.imgList.map(item => {
							that.checkImg(item.imgUrl).then(res => item.imgUrl = res).catch(err => {item.imgUrl = err; item.type = false});
							return item;
						});
						that.imgs2 = list2;
					}
				})
			},
			drawMap(obj) {
				if (obj.type) {
					this.$emit('eventMap',obj)
				}
			}
		},
		watch: {
			changeTime: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					this.getEventImgListByType(this.groupLits)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.searchImg {
		position: absolute;
		width: 1.5vw;
		height: 1.5vw;
		top: 1vw;
		right: 0.5vw;
		z-index: 99;
		cursor: pointer;
	}
	.leftBottomRight {
		width:100%;
		height: 100%;
		position: relative;
	}
	.leftBottomRight /deep/ .el-popover {
		background: #0B258C !important;
	}
	.leftBottomRight /deep/ .el-checkbox {
		width: 30px;
		height: 30px;
	}
	#dwwdwww /deep/.el-checkbox {
		//修改选中框的大小
		.el-checkbox__inner {
		  width: 0.7vw;
		  height: 0.7vw;
		  &::after {
			width:  0.2vw;
			height: 0.4vw;
			left: 0.2vw;
		  }
		}
		.el-checkbox__label {
			line-height: 1vw;
			padding-left: 0.5vw;
		}
	}
	.bottom1 {
		position: absolute;
		top: 5px;
		height: 50%;
		width: 94%;
		left: 2%;
		overflow: hidden;
		text-align: left;
	}

	.bottom2 {
		position: absolute;
		bottom: 0px;
		height: 50%;
		width: 94%;
		left: 2%;
		overflow: hidden;
		text-align: left;
	}

	.ulDiv {
		width: 23%;
		height: 100%;
		margin: 10px 1%;
		display: inline-block;
		position: relative;
		color: white;
		font-size: 0.6vw;

		.ulDom {
			position: absolute;
			top: 0px;
			left: 0px;
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			font-size: 0.6vw;
			z-index: 99;
		}

		.img1 {
			position: absolute;
			width: 100%;
			top: 0.4vw;
			left: 0px;
		}

		.img2 {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: calc(100% - 1vw);
			cursor: pointer;
			z-index: 9;
		}
	}
	.error-img {
		position: absolute;
		top: 2vw;
		left: 20%;
		z-index: 9;
		width: 60% !important;
		// margin: 1.5vw 20% 0 20% !important;
		height: auto !important;
	}
</style>



// WEBPACK FOOTER //
// src/page/customIndex/components/leftBottomRight.vue